export default {
  'personal-center.noPhone': 'No phone number',
  'personal-center.noDept': 'No department',
  'personal-center.prevLoginRegion': 'Last login location',
  'personal-center.prevLoginTime': 'Last login time',
  'personal-center.username': 'Username',
  'personal-center.email': 'Email',
  'personal-center.createTime': 'Account creation time',
  'personal-center.tab1.title': 'User information',
  'personal-center.tab1.nickname': 'Name',
  'personal-center.tab1.nickname.placeholder': 'Please enter your name, 2 to 10 characters in length',
  'personal-center.tab1.nickname.required': 'Please enter your name',
  'personal-center.tab1.nickname.pattern': '2 to 10 characters in length',
  'personal-center.tab1.mobile': 'Mobile',
  'personal-center.tab1.mobile.placeholder': 'Please enter your mobile number, 11 digits',
  'personal-center.tab1.mobile.required': 'Please enter your mobile number',
  'personal-center.tab1.mobile.pattern': 'Please enter the correct mobile number',
  'personal-center.tab1.email': 'Email',
  'personal-center.tab1.email.placeholder': 'Please enter your email',
  'personal-center.tab1.email.required': 'Please enter your email',
  'personal-center.tab1.email.pattern': 'Please enter the correct email',
  'personal-center.tab1.sex': 'Sex',
  'personal-center.tab1.sex.man': 'man',
  'personal-center.tab1.sex.woman': 'woman',
  'personal-center.tab1.sex.required': 'Please select your sex',
  'personal-center.tab2.title': 'Change Password',
  'personal-center.tab2.oldPassword': 'Old Password',
  'personal-center.tab2.oldPassword.required': 'Please enter your old password',
  'personal-center.tab2.newPassword': 'New Password',
  'personal-center.tab2.newPasswordStrength': 'Strength',
  'personal-center.tab2.newPassword.required': 'Please enter your new password',
  'personal-center.tab2.confirmPassword': 'Confirm Password',
  'personal-center.tab2.confirmPassword.required': 'Please re-enter your new password',
  'personal-center.tab2.password.placeholder': 'Please enter a password, 6 to 30 characters in length',
  'personal-center.tab2.password.pattern': '6 to 30 characters in length',
  'personal-center.tab2.password.same': 'The new password cannot be the same as the old password',
  'personal-center.tab2.password.different': 'The new password and confirmation password do not match',
  'personal-center.tab2.confirm': 'Are you sure you want to change your password?',
  'personal-center.tab2.success': 'Password successfully changed',
  // Update avatar
  'personal-center.UpdateAvatar.title': 'Change Avatar',
  'personal-center.UpdateAvatar.trigger': 'Select',
  'personal-center.UpdateAvatar.format': 'Incorrect file format. Please upload an image file, such as a JPG or PNG.',
  'personal-center.UpdateAvatar.success': 'Avatar successfully updated',
}
